// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__3dRHy","no-close":"_type_no-close__2hkBU"};